import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {PROFILE_UPDATE_FAILED, PROFILE_UPDATE_SUCCESSFUL, updateProfileInfo} from "../../Actions/passwordUpdateAction";

const PasswordUpdateSection = ({ setLoading }) => {
    const newPassCompRef = useRef(null);
    const confirmPassCompRef = useRef(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showFailed, setShowFailed] = useState(false);
    const [passMatched, setPassMatched] = useState(null);
    const partnerProfileUpdateState = useSelector(state => state.partnerProfileInfoUpdateState);
    const dispatch = useDispatch();

    useEffect(() => {
        if (partnerProfileUpdateState === PROFILE_UPDATE_SUCCESSFUL) {
            setLoading(false);
            setShowSuccess(true);
            setTimeout(() => {
                setShowSuccess(false);
            }, 5000)
        } else if (partnerProfileUpdateState === PROFILE_UPDATE_FAILED) {
            setLoading(false);
            setShowFailed(true);
            setTimeout(() => {
                setShowSuccess(false);
            }, 5000)
        }
    }, [partnerProfileUpdateState])

    const matchPass = () => {
        setShowSuccess(false);
        setShowFailed(false);
        let newPass = newPassCompRef.current.value;
        let confirmPass = confirmPassCompRef.current.value;
        if (newPass.length === 0) setPassMatched(false);
        else if (confirmPass.length === 0) setPassMatched(null);
        else if (newPass === confirmPass) setPassMatched(true);
        else setPassMatched(false);
    }

    const resetUI = () => {
        newPassCompRef.current.value = "";
        confirmPassCompRef.current.value = "";
        setPassMatched(null);
    }

    const handleUpdatePassword = () => {
        setLoading(true);
        let data = {
            "password": newPassCompRef.current.value
        }
        dispatch(updateProfileInfo(data));
        resetUI();
    }

    const scrollIntoView = () => {
        setTimeout(() => {
            document.getElementById("collapsePassUpdate").scrollIntoView({behavior: "smooth", block: "end"});
        }, 300);
    }


    return (
        <div className="accordion info-container my-5  lh-lg" id="accordionPassUpdate">
            <div className="accordion-item border-0">
                <h2 className="accordion-header" id="headingPassUpdate">
                    <button onClick={scrollIntoView} className="accordion-button ps-0 collapsed" type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsePassUpdate" aria-expanded="false"
                            aria-controls="collapsePassUpdate">
                        Update Password
                    </button>
                </h2>
                <div id="collapsePassUpdate" className="accordion-collapse border-0 collapse"
                     aria-labelledby="headingPassUpdate"
                     data-bs-parent="#accordionPassUpdate">
                    {showSuccess && <div className="alert alert-success text-center m-3" role="alert">
                        Password Updated.
                    </div>}
                    {showFailed && <div className="alert alert-danger text-center m-3" role="alert">
                        Password Update Failed!
                    </div>}
                    <div className="accordion-body passUpdateBody mx-4 p-4">
                        <div className="d-flex justify-content-center m-1 gap-10">
                            <div className="text-start pass-label">
                                <label className="info-header">New Password:</label>
                            </div>
                            <div className="">
                                <input ref={newPassCompRef} className="form-control bankInfoInput"
                                       type="password"
                                       placeholder="Enter new password"/>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center m-1 gap-10">
                            <div className="text-start pass-label">
                                <label className="info-header">Confirm Password:</label>
                            </div>
                            <div className=""><input ref={confirmPassCompRef} className="form-control bankInfoInput"
                                                     type="password"
                                                     placeholder="Confirm new password" onChange={matchPass}/>
                            </div>
                        </div>
                        {passMatched != null && !passMatched &&
                        <div className="passMismatchWarning text-danger fw-light text-center">Pass did not match</div>}
                        <div className="d-grid gap-2 col-4 mt-3 mx-auto">
                            <button className="btn passUpdateBtn" type="button" onClick={handleUpdatePassword}
                                    disabled={!passMatched}>Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PasswordUpdateSection;
